/* Promotion copy arrives as HTML written in a CMS. It is operator-authored
   rather than player-authored, but it is still content we do not control, so
   it is reduced to text instead of being injected into the page. Rendering it
   as markup would need a real sanitiser; text needs no trust at all. */

const ENTITIES: Record<string, string> = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
  "&nbsp;": " ",
};

export const toPlainText = (html: string | null | undefined) => {
  if (!html) {
    return "";
  }

  return html
    /* Block-level tags become breaks so sentences do not run together. */
    .replace(/<\s*(br|\/p|\/div|\/li|\/h[1-6])\s*\/?\s*>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&#(\d+);/g, (_, code: string) => String.fromCodePoint(Number(code)))
    .replace(/&[a-z]+;|&#39;/gi, (entity) => ENTITIES[entity.toLowerCase()] ?? entity)
    .replace(/[ \t]+/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export const truncate = (value: string, max: number) =>
  value.length <= max ? value : `${value.slice(0, max).trimEnd()}…`;

export const formatDate = (iso: string | null | undefined) => {
  if (!iso) {
    return "—";
  }

  const parsed = new Date(iso);

  if (Number.isNaN(parsed.getTime())) {
    return "—";
  }

  return parsed.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
